import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, User } from 'lucide-react';
import DataRow, { DataRowList } from '../../components/list/DataRow';
import StatusPill from '../../components/list/StatusPill';
import ListEmptyState from '../../components/list/ListEmptyState';
import ListLoadingState from '../../components/list/ListLoadingState';

function PendingEnrollmentsList({ enrollments = [], isLoading = false, viewAllTo = '/admin/enrollments' }) {
  const visible = Array.isArray(enrollments) ? enrollments.slice(0, 5) : [];

  return (
    <section>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 'var(--spacing-lg)' }}>
        <div>
          <h3 className="section-title" style={{ marginBottom: 0 }}>Pending Enrollments</h3>
          <div style={{ color: 'var(--color-text-secondary)', fontSize: '0.9rem', marginTop: '0.25rem' }}>
            Pending student course enrollments awaiting approval.
          </div>
        </div>

        <Link to={viewAllTo} className="ux-btn-sm ux-btn-ghost" style={{ textDecoration: 'none' }}>
          View all
        </Link>
      </div>

      {isLoading ? (
        <ListLoadingState label="Loading pending enrollments…" />
      ) : visible.length === 0 ? (
        <ListEmptyState
          icon={BookOpen}
          title="No pending enrollments"
          description="New submissions will appear here as students request enrollment."
        />
      ) : (
        <DataRowList>
          {visible.map((e, index) => {
            const studentName =
              e.student_name || e.student?.full_name || `${e.student_first_name ?? ''} ${e.student_last_name ?? ''}`.trim() || 'Student';
            return (
              <DataRow
                key={e.id}
                index={index}
                leading={(
                  <div className="ux-avatar">
                    <User size={16} />
                  </div>
                )}
                title={studentName}
                subtitle={(
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                    <BookOpen size={12} /> {e.course_title || e.course?.title || 'Course'}
                  </span>
                )}
                meta={<span>{e.campus_name || '—'}</span>}
                badges={<StatusPill status="pending" label="Pending" />}
              />
            );
          })}
        </DataRowList>
      )}
    </section>
  );
}

export default PendingEnrollmentsList;
